import React from 'react';
import { useCart } from '@montana/containers/cart';
import { Button } from '@montana/shared/button';
import { Link } from '@montana/shared/link';
import { Translate } from '@montana/shared/translate';
import { formatString } from '@montana/helpers/string-format/string-format.helper';
import { Price } from '@montana/shared/price';
import { SvgIcon } from '@montana/shared/svg-icon';
import { clearPopups } from '@montana/shared/popup/popup.helper';
import { MiniCartLine } from './mini-cart-line.component';
import { useDynamicSettings } from '@montana/containers/dynamic-settings';

export const MiniCartPopup: React.FC = React.memo((): JSX.Element => {
    const {
        linesToDisplay,
        totalPrice,
        accumulatedQuantity
    } = useCart();
    const { links } = useDynamicSettings();

    const closePopup = () => {
        clearPopups();
    };

    return (
        <div className="mini-cart__popup-content">
            <button className="mini-cart__popup-close" onClick={closePopup}>
                <SvgIcon iconName="close" />
            </button>
            {
                linesToDisplay?.length ? (
                    <>
                        <h2>
                            <Translate value={(t): string => t.miniBasket.itemsInShoppingBag} defaultValue={`[{0} item(s) in shopping bag]`}>{(t): string => formatString(t, accumulatedQuantity)}</Translate>
                        </h2>
                        <ul className="mini-cart__list">
                            {
                                linesToDisplay.map((line): JSX.Element => (
                                    <li key={line.code}>
                                        <MiniCartLine productLine={line} />
                                    </li>
                                ))
                            }
                        </ul>

                        <div className="mini-cart__summary">
                            <span><Translate value={(t): string => t.miniBasket.subTotal} defaultValue="Sub-total" /></span>
                            <span><Price obj={totalPrice} /></span>
                        </div>

                        <Link to={links?.cart || '/cart'}>
                            <Button style="tertiary" className="mini-cart__button">
                                <Translate value={(t): string => t.miniBasket.goToShoppingBag} defaultValue="Go to shopping bag ({0})">
                                    {(t): string => formatString(t, accumulatedQuantity)}
                                </Translate>
                            </Button>
                        </Link>
                    </>
                ) : (
                    <p className="">
                        <Translate value={(t): string => t.miniBasket.shoppingBagIsEmpty} defaultValue="Shopping bag is empty" />
                    </p>
                )
            }
        </div>
    );
});
